import { EventBus } from '../../event-bus.js'

export default {
    default: (app) => {
        // const $playVideoButton = document.querySelector('.js-play-video-button')
        
        function showModal(contents) {
            EventBus.$emit('open-global-modal', contents);
        }

        // $playVideoButton.addEventListener('click', e => {
        //     let modalContents = {
        //         title: '',
        //         video: e.target.dataset.videoEmbedUrl
        //     }
        //     showModal(modalContents) 
        // } );
    }
}
